import './styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'

import ModalWrapper from 'components/ModalWrapper'
import { Text, ColorPicker } from 'components/SmartChatView/Fields'

const LabelModalUI = ({ isOpen, toggle, mode, labelName, setLabelName, labelColor, setLabelColor, handleSave, modalLoading, modalError }) => (
  <ModalWrapper
    isOpen={isOpen}
    toggle={toggle}
    header={I18n.t(`smartchat_label_header_${mode}`)}
    legend={I18n.t(`smartchat_label_legend_${mode}`)}
    eventBtnTxt={I18n.t(`dashboard_${mode}-label`)}
    eventBtn={handleSave}
    cancelBtnTxt={I18n.t('dashboard_cancel')}
    cancelBtn={toggle}
    isSubmitting={modalLoading}
    error={modalError && I18n.t(modalError.message)}
    contentClassName='smartchat-modal'
    body={
      <div className='modal-content modal-content--spaced'>
        <Text
          isRequired
          label={I18n.t('dashboard_name')}
          placeholder={I18n.t('dashboard_example_welcome')}
          value={labelName}
          onChange={setLabelName}
        />
        <ColorPicker
          isRequired
          label={I18n.t('dashboard_color')}
          value={labelColor}
          onChange={setLabelColor}
        />
      </div>
    }
  />
)

export default LabelModalUI
